import { message } from 'antd';
import axios from 'axios';

// 创建一个axios实例 除了登陆用axios 其他之外的都用这个apiClient，统一校验token是否存在
const apiClient = axios.create({
  baseURL: '/api', // 这里设置基础路径
  timeout: 20000,
});

// 添加请求拦截器
apiClient.interceptors.request.use((config) => {

  const token = localStorage.getItem("token");
  if (token) {
    config.headers['Authorization'] = `${token}`;

    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    } else {
      config.headers['Content-Type'] = 'application/json';
    }
  } else {
    delete config.headers['Authorization'];
    window.dispatchEvent(new CustomEvent('auth:logout'));
  }

  return config;
});

// 添加响应拦截器
apiClient.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response;
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 400:
          message.error('Error:' + error.response);
          break;
        case 401:
          localStorage.removeItem("token");
          localStorage.removeItem('userInfo');
          localStorage.setItem('userStatus', 'logout');

          window.dispatchEvent(new CustomEvent('auth:logout'));
          break;
        case 403:
          message.error('您没有权限访问此资源！');
          break;
        default:
          message.error('Error:' + error.response);
      }
    } else if (error.request) {
      console.error('No response received:', error.request);
    } else {
      console.error('Error setting up request:', error.message);
    }
    return Promise.reject(error);
  }
);


export default apiClient;